import React from 'react';
import { Shield, Lock, CreditCard } from 'lucide-react';
import { CountdownTimer } from './PricingSection';
export function FinalCtaSection() {
  return <section className="cv-auto py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-950 relative overflow-hidden" data-id="element-69">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full bg-purple-600/10 blur-[100px] rounded-full pointer-events-none hidden md:block" data-id="element-70" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-71">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-72">
          ❤️ La infancia de tus hijos no se pausa
        </h2>

        <p className="text-xl md:text-2xl text-purple-300 font-medium italic mb-4 max-w-3xl mx-auto" data-id="element-73">
          «No necesitás más tiempo. Necesitás mejores momentos. Hoy podés
          empezar.»
        </p>

        <p className="text-lg md:text-xl text-slate-300 mb-12 max-w-3xl mx-auto" data-id="element-74">
          Dentro de unos años… no van a recordar la pantalla. Van a recordar lo
          que vivieron con vos.
        </p>

        <div className="mb-12" data-id="element-75">
          <p className="text-red-400 font-bold mb-4" data-id="element-76">⏰ EL PRECIO CIERRA EN:</p>
          <CountdownTimer data-id="element-77" />
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto mb-12" data-id="element-78">
          {/* Pack Básico */}
          <div className="bg-navy-900 border border-navy-800 rounded-2xl p-6 flex flex-col justify-between" data-id="element-79">
            <div data-id="element-80">
              <h3 className="text-lg font-bold text-white mb-1" data-id="element-81">
                📘 PACK BÁSICO
              </h3>
              <p className="text-sm text-slate-400 mb-4" data-id="element-82">
                4 libros + 400 citas + bonos
              </p>
              <div className="flex items-end justify-center gap-2 mb-6" data-id="element-83">
                <span className="text-lg text-slate-500 line-through" data-id="element-84">$65</span>
                <span className="text-3xl font-bold text-white" data-id="element-85">$9.99</span>
              </div>
            </div>
            <button onClick={() => window.open('https://recursopack.com/cart/40898068152369:1', '_blank')} className="w-full bg-navy-800 hover:bg-navy-700 border border-blue-500/30 text-white font-bold py-3 px-4 rounded-xl transition-colors text-center cursor-pointer text-sm" data-id="element-86">
              → QUIERO MI PACK BÁSICO
            </button>
            <p className="text-center mt-3 text-[10px] md:text-xs text-purple-400/70 font-medium" data-id="element-87">
              🌎 Pagalo en tu moneda local
            </p>
          </div>

          {/* Pack Completo */}
          <div className="bg-gradient-to-b from-navy-800 to-navy-900 border border-gold-500 rounded-2xl p-6 flex flex-col justify-between shadow-[0_0_30px_rgba(234,179,8,0.1)]" data-id="element-88">
            <div data-id="element-89">
              <h3 className="text-lg font-bold text-white mb-1" data-id="element-90">
                🏆 PACK COMPLETO ⭐
              </h3>
              <p className="text-sm text-gold-400 mb-4" data-id="element-91">
                6 libros + 600 citas + bonos
              </p>
              <div className="flex items-end justify-center gap-2 mb-6" data-id="element-92">
                <span className="text-lg text-slate-500 line-through" data-id="element-93">$95</span>
                <span className="text-3xl font-bold text-white" data-id="element-94">$14.99</span>
              </div>
            </div>
            <button onClick={() => window.open('https://recursopack.com/cart/40916383236145:1', '_blank')} className="w-full bg-gradient-to-r from-gold-500 to-yellow-400 hover:from-gold-400 hover:to-yellow-300 text-navy-900 font-bold py-3 px-4 rounded-xl transition-all transform hover:scale-105 text-center cursor-pointer text-sm" data-id="element-95">
              → QUIERO EL PACK COMPLETO
            </button>
            <p className="text-center mt-3 text-[10px] md:text-xs text-purple-400/70 font-medium" data-id="element-96">
              🌎 Pagalo en tu moneda local
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs md:text-sm text-slate-400" data-id="element-97">
          <span className="flex items-center gap-1.5" data-id="element-98">
            <Lock className="w-4 h-4 text-purple-400" data-id="element-99" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-100">
            <Shield className="w-4 h-4 text-purple-400" data-id="element-101" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-102">
            <CreditCard className="w-4 h-4 text-purple-400" data-id="element-103" /> Tarjeta de
            crédito, débito y más
          </span>
        </div>
        <p className="mt-4 text-xs md:text-sm text-purple-400/70 font-medium" data-id="element-104">
          🌎 Pagalo en tu moneda local
        </p>
      </div>
    </section>;
}